/**
 * Les choix du patron pour le pointage de ses employés (Réglages → Pointage).
 *
 * <p>Les heures : automatiques (l'heure du téléphone au moment où l'employé
 * pointe, qu'il ne peut pas changer) ou manuelles (il peut corriger son
 * arrivée et son départ). Ce qu'il a fait : coché dans les postes de l'offre,
 * écrit par lui-même — un menuisier qui travaille sur plusieurs meubles de
 * chantiers différents l'écrit plus vite —, ou les deux. L'atelier : pour les
 * métiers qui fabriquent à l'atelier avant de poser sur le chantier, l'employé
 * dit où il a travaillé (sur le chantier, à l'atelier pour un chantier, ou à
 * l'atelier en général).
 */

export const CLE_POINTAGE_HEURES = 'pointage.heures';
export const CLE_POINTAGE_TRAVAUX = 'pointage.travaux';
export const CLE_POINTAGE_ATELIER = 'pointage.atelier';

/**
 * Les réglages du pointage, avec leurs valeurs par défaut : heures
 * manuelles, travaux cochés ou écrits.
 *
 * @param {(cle: string, defaut?: string) => string} reglage lecture d'un réglage de la société
 * @returns {{heures: 'auto'|'manuel', travaux: 'postes'|'texte'|'les_deux', atelier: boolean}} les choix
 */
export function reglagesPointage(reglage) {
  const heures = reglage(CLE_POINTAGE_HEURES, 'manuel') === 'auto' ? 'auto' : 'manuel';
  const t = reglage(CLE_POINTAGE_TRAVAUX, 'les_deux');
  const travaux = t === 'postes' || t === 'texte' ? t : 'les_deux';
  const atelier = reglage(CLE_POINTAGE_ATELIER, 'non') === 'oui';
  return { heures, travaux, atelier };
}
